import { render, staticRenderFns } from "./abw.vue?vue&type=template&id=0ead0590&"
import script from "./abw.vue?vue&type=script&lang=js&"
export * from "./abw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports